import React from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { apiURL } from "../config/common";

export default function Programme() {

  let app = ApplicantContainer.useContainer();

  let ProgrammeOffer = app.showProgrammeOffer;
  let IntakeNoOffer = app.showIntakesNoOffer;
  
  function handleChange(evt) {        

    app.onChangeInStdValues({...app.inStdValues, [evt.target.id]:evt.target.value});
  }
  
  function getIntake(e) {

    app.inStdValues.frIntake='';

    if(e.target.value === null || e.target.value === "") {    
      app.setprogrammmeChosen('');
      app.setIntakesNoOffer([]);
      app.setIntakeNoChosen('');   
      handleChange(e);
    }
     else  { //e.target.value !== null


      fetch(apiURL + "/intakes-e",{
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({"scholarshipChosen": app.scholarshipChosen, "programmeChosen": e.target.value })
      })
      .then(res => res.json())
      .then(
          (result) => {            
            app.setIntakesNoOffer(result);   
  
          },

          (error) => {
            //console.log(error);
          }
      )
    } 
  }

  function reloadIntake(e) {
      app.setIntakeNoChosen(e.target.value);
  }
  
  //console.log(ProgrammeOffer)
    return (
    <>
    <Form.Row>
      <Col xs={12} sm={8}>        
          <Form.Group as={Col} controlId="frProgramme" name="frProgramme">
          <Form.Label>Programme</Form.Label>      
          <Form.Control required as="select"   
    
          value={app.inStdValues.frProgramme}
          onChange={(e) => {getIntake(e); handleChange(e)}} >
          <option key="" value="">
              --- SELECT A Programme --- 
            </option>
          {ProgrammeOffer.map((item) => 
            // <option key={item.COURSE_CODE} value={item.COURSE_CODE}>
            //   {item.COURSE_DESCRIPTION}
            // </option>
            <optgroup label={item.LEVEL} key={item.LEVEL}>
            {
              item.COURSE.map((courseitem) =>
              <option key={courseitem.COURSE_CODE} value={courseitem.COURSE_CODE}>
              {courseitem.COURSE_DESCRIPTION}
              </option>
              )}
          </optgroup>
          )}
          </Form.Control>
          </Form.Group>
      </Col>   
      <Col xs={12} sm={4}>        
          <Form.Group as={Col} controlId="frIntake" name="frIntake">
          <Form.Label>Intake</Form.Label>      
          <Form.Control required as="select"   
    
          value={app.inStdValues.frIntake}
          onChange={(e) => {reloadIntake(e); handleChange(e)}} >
          <option key="" value="">
              --- SELECT A Intake --- 
            </option>
          {IntakeNoOffer.map((item) => 
            <option key={item.INTAKE_NUMBER+ "-" + item.STUDY_MODE} value={item.INTAKE_NUMBER+ "-" + item.STUDY_MODE}>
              {item.INTAKE_NUMBER + " - " + item.STUDY_MODE}
            </option>
          )}
          </Form.Control>
          </Form.Group>
      </Col>
    </Form.Row> 
    </>
    );


}